/* ================================================== */
/* UTILS → Is in viewport?
/* ================================================== */

$.fn.isInViewport = function() {
	var elementTop = $(this).offset().top,
		elementBottom = elementTop + $(this).outerHeight();
		viewportTop = $(window).scrollTop();
		viewportBottom = viewportTop + $(window).height();
	return elementBottom > viewportTop && elementTop < viewportBottom;
};